module.exports = __webpack_public_path__ + "static/65import-40bd5f9598a95f0db5baf5d94a2f5567.png";